const SHIFT = 3;

export const deobfuscate = (encoded: string): string => {
  const binary = atob(encoded);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = (binary.charCodeAt(i) - SHIFT + 256) & 0xff;
  }
  return new TextDecoder().decode(bytes);
};
